import { useMutation } from "react-query";
import { endpoints } from "utils/endpoints";
import http from "utils/http";

const addLocationGetInTouch = (postData) => {
  return http().post(endpoints.forms.locationGetInTouch, postData);
};

export function useLocationGetInTouch() {
  return useMutation(addLocationGetInTouch, {
    onError: (errorData) => {
      const errorMessage = errorData?.error?.message || errorData?.message;
      alert(errorMessage);
    },
  });
}
